<template>
 <div id="page-wrap" v-if="loggedIn">
   <PageHeader></PageHeader>
   <div class="container content-wrap">
     <div class="row">
       <div class="hidden-xs col-md-10 col-md-offset-1">
          <QuickLinks ></QuickLinks>
       </div>
       <ProfileContent class="hidden-xs hidden-sm" :nav="'payment-history'"></ProfileContent>
       <PaymentHistory></PaymentHistory>

       <MobileNav :activeLink="'profile'" class="visible-xs"></MobileNav>
     </div>
   </div>
 </div>
</template>

<script>
import PageHeader from './PageHeader/index'
import PaymentHistory from './PaymentHistory/index'
import ProfileContent from './ProfileContent/index'
import QuickLinks from './QuickLinks/index'
import MobileNav from './MobileNav/index'
import { mapGetters } from 'vuex'

export default {
  name: 'Paymenthistory',
  data () {
    return {

    }
  },
  components: { PageHeader, PaymentHistory, ProfileContent, MobileNav, QuickLinks },
  mounted () {
  },

  computed: {
    ...mapGetters([
      "loggedIn"
    ])
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Paymenthistory.vue